import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { candidates } from '@/data/mockData';
import { CandidateCard } from '@/components/candidates/CandidateCard';
import { CandidateProfile } from '@/components/candidates/CandidateProfile';
import { ScheduleInterviewModal } from '@/components/modals/ScheduleInterviewModal';
import { AssignTaskModal } from '@/components/modals/AssignTaskModal';
import type { Candidate } from '@/data/mockData';
import { useState } from 'react';
import { toast } from 'sonner';
import { Calendar } from 'lucide-react';

const InterviewedPage = () => {
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [interviewOpen, setInterviewOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);

  const interviewedCandidates = candidates.filter((c) => c.status === 'interviewed');

  const handleViewProfile = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setProfileOpen(true);
  };

  const handleShortlist = (candidate: Candidate) => {
    toast.success(`${candidate.name} has been shortlisted!`);
  };

  const handleScheduleInterview = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setProfileOpen(false);
    setInterviewOpen(true);
  };

  const handleAssignTask = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setProfileOpen(false);
    setTaskOpen(true);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Calendar className="h-6 w-6 text-accent" />
            Interviewed Candidates
          </h1>
          <p className="text-muted-foreground">
            Candidates who have completed interviews.
          </p>
        </div>

        {interviewedCandidates.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border py-12">
            <Calendar className="h-12 w-12 text-muted-foreground" />
            <p className="mt-2 text-lg font-medium text-muted-foreground">No interviewed candidates</p>
            <p className="text-sm text-muted-foreground">
              Schedule interviews to see completed ones here.
            </p>
          </div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {interviewedCandidates.map((candidate) => (
              <CandidateCard
                key={candidate.id}
                candidate={candidate}
                onViewProfile={handleViewProfile}
                onShortlist={handleShortlist}
                onScheduleInterview={handleScheduleInterview}
              />
            ))}
          </div>
        )}
      </div>

      <CandidateProfile
        candidate={selectedCandidate}
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        onShortlist={handleShortlist}
        onScheduleInterview={handleScheduleInterview}
        onAssignTask={handleAssignTask}
      />
      <ScheduleInterviewModal
        candidate={selectedCandidate}
        open={interviewOpen}
        onClose={() => setInterviewOpen(false)}
      />
      <AssignTaskModal
        candidate={selectedCandidate}
        open={taskOpen}
        onClose={() => setTaskOpen(false)}
      />
    </DashboardLayout>
  );
};

export default InterviewedPage;
